import React, { useState } from "react";
import { Square } from "./Square";

import "./Board.css";

export function Board({ choices, includeFreeTile }) {
  const [selectedSquares, setSelectedSquares] = useState(new Set());

  const toggleSquare = (text) => {
    const toggled = new Set(selectedSquares);

    if (toggled.has(text)) {
      toggled.delete(text);
    } else {
      toggled.add(text);
    }
    setSelectedSquares(toggled);
  };

  /*
  Build Squares
  */
  const squares = [[], [], [], [], []];
  let i = 0;
  for (let text of choices) {
    squares[i % 5].push(
      <Square
        key={i}
        text={text}
        isMarked={selectedSquares.has(text)}
        onMark={(squareText) => toggleSquare(squareText)}
      />
    );
    i++;
  }

  if (includeFreeTile) {
    squares[2][2] = 
    <Square
      key='free-tile'
      text='Free!'
      isMarked={true}
      onMark={() => {}}
    />
  }

  /*
  Build Rows
  */
  const rows = squares.map((s, index) => (
    <div key={index} className="row">
      {s}
    </div>
  ));

  return <div className="board">{rows}</div>;
}
